exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booking-info[data-v-5c93ff9e]{padding:1rem;background-color:#dae8f4;border:1px solid var(--blue-light-4);border-left:4px solid var(--blue);border-radius:4px}.booking-error[data-v-5c93ff9e]{padding:1rem;background-color:#feeeed;border:1px solid #e12f22;border-left:4px solid #e12f22;border-radius:4px;align-items:start;display:flex;margin-top:1rem}@media(max-width:600px){.booking-info[data-v-5c93ff9e]{background-color:transparent}}", ""]);

// exports
